var hello = function () {
  return 'hello world ！welcome use sunduan-util';
}

module.exports = hello



// WEBPACK FOOTER //
// ./lib/hello.js